import axios from 'axios'
import store from '../../store'
import router from '../../router'
import { getLang } from '../../i18n'

const getHostId = () =>
  localStorage.getItem('host_id') || process.env.VUE_APP_HOST_ID

export function getPerfumes (ids) {
  let lang = getLang()
  let hostId = getHostId()
  return axios
    .get(
      process.env.VUE_APP_API_URL +
        `/perfumes/by_ids?sortByEntryOrder=true&allPresent=false&perfumeIds=${ids.join(
          ','
        )}&hostId=${hostId}&lang=${lang}`
    )
    .then(res => res.data)
}
export function getPerfume (id) {
  let lang = getLang()
  let hostId = getHostId()
  let cached = store.getters.getById(id)
  if (cached)
    return new Promise(function (resolve) {
      resolve(cached)
    })
  return axios
    .get(
      process.env.VUE_APP_API_URL +
        `/perfumes/${id}?hostId=${hostId}&lang=${lang}`
    )
    .then(response => {
      store.dispatch('saveById', { id: id, data: response.data })
      return response.data
      // return new Promise(function(resolve) {
      //   setTimeout(()=>{
      //     resolve(response.data)
      //   },1000)
      // });
    })
}
export function track (event) {
  let { data, ...partialEvent } = event
  let eventTransmitted = {
    ...partialEvent,
    data: data,
    app: 'beauti_qr',
    uuid: router.currentRoute.query.uuid
  }
  console.log(eventTransmitted)

  return axios
    .post(process.env.VUE_APP_API_URL + '/usage/saveAction', eventTransmitted)
    .then(response => {
      console.log(response)
    })
}
